import React from "react";
import { View, TouchableOpacity, StyleSheet } from "react-native";
import Text from "@components/CustomText";
import color from "@constants/color";

const Filter = ({ onToggleAllSwitch = () => {} }) => {
  return (
    <View style={styles.container}>
      <TouchableOpacity
        testID="ofd-filter-all-select"
        onPress={() => onToggleAllSwitch(true)}
        style={styles.pill}
      >
        <Text variant="body_text_3" style={styles.text}>
          All Select
        </Text>
      </TouchableOpacity>
      <TouchableOpacity
        testID="ofd-filter-all-deselect"
        onPress={() => onToggleAllSwitch(false)}
        style={styles.pill}
      >
        <Text variant="body_text_3" style={styles.text}>
          All Deselect
        </Text>
      </TouchableOpacity>
    </View>
  );
};
export default Filter;

const styles = StyleSheet.create({
  container: {
    padding: 10,
    paddingBottom: 4,
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  pill: {
    backgroundColor: color.white,
    borderRadius: 30,
    padding: 8,
    marginHorizontal: 6,
    paddingHorizontal: 12,
  },
});
